import * as z from 'zod';

import { emailSchema } from '@/_schemas/generic';

export const forgotPasswordFormSchema = z.object({
  email: emailSchema(false),
});

export type ForgotPasswordFormSchema = z.infer<typeof forgotPasswordFormSchema>;

export const FORGOT_PASSWORD_FORM_DEFAULT_VALUES: ForgotPasswordFormSchema = {
  email: '',
};
